import { __nextBrowser as nextBrowser } from 'scripts/nextBrowser';
import { __PostsFiltersType } from './posts.type';

const __POSTS_LIST_PATH = '/posts';

/** Builds the posts list URL from filters. Kept separate from posts.script to avoid a data ↔ posts circular import. */
export const __PostsPageURL = (filters: __PostsFiltersType): URL => {
    const params: { [key: string]: string } = {};
    if (filters.page && filters.page !== 1) params.page = filters.page.toString();
    if (filters.search) params.search = filters.search;
    if (filters.category) params.category = filters.category.slug;
    const path = new URL(
        (process.env.NEXT_PUBLIC_HOST ?? nextBrowser?.window?.location.origin ?? '') + __POSTS_LIST_PATH,
    );
    Object.entries(params).map((item) => path.searchParams.append(item[0], item[1]));
    filters.categoryFields?.map((f) => path.searchParams.append(`category_field[${f.id}]`, f.value.toString()));
    filters.ranges?.map((f) => path.searchParams.append(`range_category_field[${f.id}]`, f.value.toString()));
    return path;
};
